if (!customElements.get('testimonials-slider') && typeof SliderComponent !== 'undefined') {
  class TestimonialsSlider extends SliderComponent {
    constructor() {
      super();
      if (!this.slider || !this.nextButton) return;

      this.buttons = this.querySelector('[data-testimonial-buttons]');
      this.fadeEnabled = this.dataset.enableFade !== 'false';
      this.loopEnabled = this.dataset.enableLoop !== 'false';

      if (this.fadeEnabled) this.classList.add('testimonials-slider--fade');

      if (this.loopEnabled) {
        this.setupTransformLoop();
      } else if (this.fadeEnabled) {
        this.updateVisibility();
      }
    }

    setupTransformLoop() {
      this.realSlides = Array.from(this.sliderItems);
      this.total = this.realSlides.length;
      if (this.total < 2) {
        if (this.fadeEnabled) this.updateVisibility();
        return;
      }

      this.columnsDesktop = parseInt(this.dataset.columnsDesktop, 10) || 1;
      this.mqlTablet = window.matchMedia('(min-width: 750px)');
      this.mqlDesktop = window.matchMedia('(min-width: 990px)');

      this.bufferSize = Math.min(this.columnsDesktop, this.total);

      const leadFragment = document.createDocumentFragment();
      this.realSlides.slice(-this.bufferSize).forEach((item, index) => {
        leadFragment.appendChild(this.createLoopClone(item, `lead-${index}`));
      });
      this.slider.insertBefore(leadFragment, this.slider.firstChild);

      const tailFragment = document.createDocumentFragment();
      this.realSlides.slice(0, this.bufferSize).forEach((item, index) => {
        tailFragment.appendChild(this.createLoopClone(item, `tail-${index}`));
      });
      this.slider.appendChild(tailFragment);

      this.allSlides = Array.from(this.slider.children);
      this.currentIndex = 0;
      this.classList.add('testimonials-slider--transform');

      this.onLoopTransitionEnd = (event) => {
        if (event.target === this.slider) this.handleLoopBoundary();
      };
      this.onLoopBreakpointChange = () => {
        this.updateLoopPageSize();
        this.renderLoop(false);
      };

      this.slider.addEventListener('transitionend', this.onLoopTransitionEnd);
      this.mqlTablet.addEventListener('change', this.onLoopBreakpointChange);
      this.mqlDesktop.addEventListener('change', this.onLoopBreakpointChange);

      this.updateLoopPageSize();
      this.renderLoop(false);
    }

    createLoopClone(item, suffix) {
      const clone = item.cloneNode(true);
      clone.id = `${item.id}-clone-${suffix}`;
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-clone', '');
      clone.querySelectorAll('a, button').forEach((focusable) => {
        focusable.tabIndex = -1;
      });
      return clone;
    }

    getLoopPageSize() {
      if (this.mqlDesktop.matches) return this.columnsDesktop;
      if (this.mqlTablet.matches) return Math.min(this.columnsDesktop, 2);
      return 1;
    }

    updateLoopPageSize() {
      this.loopPageSize = Math.min(this.getLoopPageSize(), this.total);
      this.style.setProperty('--testimonials-loop-page-size', this.loopPageSize);
      if (this.buttons) {
        this.buttons.hidden = this.loopPageSize >= this.total;
      }
    }

    onButtonClick(event) {
      event.preventDefault();
      if (!this.loopEnabled) {
        super.onButtonClick(event);
        return;
      }

      const direction = event.currentTarget.name === 'next' ? 1 : -1;
      this.currentIndex += direction;
      this.renderLoop(true);
    }

    renderLoop(withTransition) {
      const domIndex = this.bufferSize + this.currentIndex;

      this.slider.style.transition = withTransition ? '' : 'none';
      if (!withTransition) this.setSlidesTransition('none');

      this.style.setProperty('--testimonials-loop-index', domIndex);
      this.updateLoopVisibility(domIndex);

      if (!withTransition) {
        void this.slider.offsetHeight;
        this.slider.style.transition = '';
        this.setSlidesTransition('');
      }
    }

    setSlidesTransition(value) {
      this.allSlides.forEach((item) => {
        item.style.transition = value;
      });
    }

    handleLoopBoundary() {
      if (this.currentIndex >= this.total) {
        this.currentIndex -= this.total;
        this.renderLoop(false);
      } else if (this.currentIndex < 0) {
        this.currentIndex += this.total;
        this.renderLoop(false);
      }
    }

    updateLoopVisibility(domIndex) {
      if (!this.fadeEnabled) return;
      this.allSlides.forEach((item, index) => {
        const inView = index >= domIndex && index < domIndex + this.loopPageSize;
        item.classList.toggle('is-visible', inView);
      });
    }

    disconnectedCallback() {
      this.slider?.removeEventListener('transitionend', this.onLoopTransitionEnd);
      this.mqlTablet?.removeEventListener('change', this.onLoopBreakpointChange);
      this.mqlDesktop?.removeEventListener('change', this.onLoopBreakpointChange);
      this.slider?.querySelectorAll('[data-clone]').forEach((clone) => clone.remove());
    }

    update() {
      super.update();
      if (this.fadeEnabled && !this.loopEnabled) this.updateVisibility();
    }

    updateVisibility() {
      this.sliderItemsToShow?.forEach((item) => {
        item.classList.toggle('is-visible', this.isSlideVisible(item));
      });
    }

    isSlideVisible(element, offset = 0) {
      const tolerance = 1;
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return (
        element.offsetLeft + element.clientWidth <= lastVisibleSlide + tolerance &&
        element.offsetLeft >= this.slider.scrollLeft - tolerance
      );
    }
  }

  customElements.define('testimonials-slider', TestimonialsSlider);
}
